import React, { useState } from 'react';
import {
  Container,
  Typography,
  Box,
  TextField,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Link,
  Paper,
  CircularProgress,
  Fade,
  useTheme,
  useMediaQuery,
  IconButton, // Added
  InputAdornment, // Added
} from '@mui/material';
import {
  //HealthAndSafety as HealthIcon,
  Login as LoginIcon,
  PersonAdd as RegisterIcon,
  Visibility, // Added
  VisibilityOff, // Added
} from '@mui/icons-material';
import { login } from '../services/api_service';
import { useAlert } from '../AlertContext';

const ModernLogin = () => {
  const [state, setState] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // Added
  const { showAlert, setSession } = useAlert();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const onChange = (key, value) => {
    setState((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleLogin = async () => {
    if (
      !state.identification_type ||
      !state.identification_number ||
      !state.password
    ) {
      showAlert('Por favor complete todos los campos', 'warning');
      return;
    }

    setLoading(true);
    try {
      const response = await login(state);
      if (response) {
        const sessionData = {
          token: response.token,
          user_id: response.data.id,
          user_name: response.data.name,
          plan_id: response.data.plan_id,
          identification_number: response.data.identification_number,
          phone: response.data.phone,
          email: response.data.email,
          is_admin: response.data.is_admin,
        };

        localStorage.setItem('session', JSON.stringify(sessionData));
        setSession(sessionData);

        window.location.pathname = response.data.is_admin
          ? '/admin-tasks'
          : '/';
      }
    } catch (error) {
      showAlert(
        'Error durante la autenticación, revise sus credenciales',
        'error'
      );
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleLogin();
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #94B754 0%, #7DA647 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
      }}
    >
      <Container maxWidth="sm">
        <Fade in={true} timeout={800}>
          <Paper
            elevation={24}
            sx={{
              p: { xs: 3, md: 4 },
              borderRadius: 4,
              background: 'rgba(255, 255, 255, 0.95)',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
            }}
          >
            {/* Logo and Header */}
            <Box sx={{ textAlign: 'center', mb: 4 }}>
              {/* <img
                src="/white-logo.png"
                alt="Clodan Logo"
                style={{ height: 40 }}
              />
              <Box
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 80,
                  height: 80,
                  borderRadius: '50%',
                  background:
                    'linear-gradient(135deg, #94B754 0%, #7DA647 100%)',
                  mb: 2,
                }}
              >
                <HealthIcon sx={{ fontSize: 40, color: 'white' }} />
              </Box>
              <Typography
                variant={isMobile ? 'h4' : 'h3'}
                sx={{
                  fontWeight: 'bold',
                  color: '#2C5530',
                  mb: 1,
                }}
              >
                Clodan
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                Clínica Dental - Portal de Pacientes
              </Typography>*/}
              <Typography
                variant={isMobile ? 'h5' : 'h4'}
                sx={{
                  fontWeight: 'bold',
                  color: '#2C5530',
                }}
              >
                Iniciar Sesión
              </Typography>
            </Box>

            {/* Login Form */}
            <Box component="form" onKeyPress={handleKeyPress}>
              <FormControl
                fullWidth
                sx={{
                  mb: 3,
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                  },
                }}
              >
                <InputLabel>Tipo de Identificación</InputLabel>
                <Select
                  value={state.identification_type || ''}
                  label="Tipo de Identificación"
                  onChange={(e) =>
                    onChange('identification_type', e.target.value)
                  }
                  disabled={loading}
                >
                  <MenuItem value="CC">Cédula de ciudadanía</MenuItem>
                  <MenuItem value="CE">Cédula de extranjería</MenuItem>
                  <MenuItem value="TI">Tarjeta de identidad</MenuItem>
                  {/*<MenuItem value="NIT">NIT</MenuItem>
                  <MenuItem value="PB">Pasaporte</MenuItem>*/}
                </Select>
              </FormControl>

              <TextField
                label="Número de Identificación"
                fullWidth
                variant="outlined"
                value={state.identification_number || ''}
                onChange={(e) =>
                  onChange('identification_number', e.target.value)
                }
                disabled={loading}
                sx={{
                  mb: 3,
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                  },
                }}
              />

              <TextField
                label="Contraseña"
                fullWidth
                variant="outlined"
                type={showPassword ? 'text' : 'password'}
                value={state.password || ''}
                onChange={(e) => onChange('password', e.target.value)}
                disabled={loading}
                sx={{
                  mb: 4,
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword(!showPassword)}
                        onMouseDown={(event) => event.preventDefault()}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Button
                variant="contained"
                fullWidth
                size="large"
                onClick={handleLogin}
                disabled={loading}
                startIcon={
                  loading ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    <LoginIcon />
                  )
                }
                sx={{
                  py: 1.5,
                  borderRadius: 2,
                  background:
                    'linear-gradient(135deg, #94B754 0%, #7DA647 100%)',
                  fontWeight: 'bold',
                  fontSize: '1.1rem',
                  textTransform: 'none',
                  boxShadow: '0 4px 12px rgba(148, 183, 84, 0.4)',
                  '&:hover': {
                    background:
                      'linear-gradient(135deg, #7DA647 0%, #6B8F3A 100%)',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 6px 16px rgba(148, 183, 84, 0.5)',
                  },
                  '&:disabled': {
                    background: '#ccc',
                    transform: 'none',
                    boxShadow: 'none',
                  },
                }}
              >
                {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
              </Button>
            </Box>

            {/* Register Link */}
            <Box sx={{ textAlign: 'center', mt: 3 }}>
              <Typography variant="body2" color="text.secondary">
                ¿No tienes una cuenta?
              </Typography>
              <Button
                component={Link}
                href="/register"
                startIcon={<RegisterIcon />}
                sx={{
                  mt: 1,
                  color: '#94B754',
                  fontWeight: 'bold',
                  textTransform: 'none',
                  '&:hover': {
                    backgroundColor: 'rgba(148, 183, 84, 0.1)',
                  },
                }}
              >
                Crear cuenta nueva
              </Button>
            </Box>
          </Paper>
        </Fade>
      </Container>
    </Box>
  );
};

export default ModernLogin;
